var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 21.5,
    viewBox: "0 0 19.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_38c9717c13e2f774069f7362cc54b900",
    "data-name": "38c9717c13e2f774069f7362cc54b900",
    transform: "translate(-2.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51102",
    "data-name": "Path 51102",
    d: "M6,2.75A2.25,2.25,0,0,0,3.75,5V19A2.25,2.25,0,0,0,6,21.25H18A2.25,2.25,0,0,0,20.25,19V9.086a2.25,2.25,0,0,0-.521-1.44L16.323,3.56a2.25,2.25,0,0,0-1.729-.81ZM2.25,5A3.75,3.75,0,0,1,6,1.25h8.595A3.75,3.75,0,0,1,17.476,2.6l3.405,4.086a3.75,3.75,0,0,1,.869,2.4V19A3.75,3.75,0,0,1,18,22.75H6A3.75,3.75,0,0,1,2.25,19Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51103",
    "data-name": "Path 51103",
    d: "M15,1.75a.75.75,0,0,1,.75.75V6A2.25,2.25,0,0,0,18,8.25h2.5a.75.75,0,0,1,0,1.5H18A3.75,3.75,0,0,1,14.25,6V2.5A.75.75,0,0,1,15,1.75Zm-.47,12.72a.75.75,0,0,0-1.061,0l-.72.72V11a.75.75,0,0,0-1.5,0v4.189l-.72-.72A.75.75,0,0,0,9.47,15.53l2,2a.75.75,0,0,0,1.061,0l2-2A.75.75,0,0,0,14.53,14.47Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.93205d432d17a9f40369e9ef87f15819.svg";
export { ForwardRef as ReactComponent };